import Vue from 'vue'
import accounts from "@/api/accounts";
import ddMandateHistory from './ddMandateHistory';

const getDefaultState = () => {
  return {
    accounts: [],
    accountsLoading: true,
    currentAccount: {},
    currentAccountLoading: true,

    updateAccountLoading: false,
    updateAccountError: false,
    updateAccountErrorMessage: null,

    currentAccountNotes: [],
    currentAccountNotesLoading: false,
    currentAccountNotesError: false,
    accountEscalation: false,
    creditData: {},
    creditReasons: [],
    creditReasonsLoading: false,
    crmUsers: {},
  
    currentAccountAuditLoading: false,
    currentAccountAudit: {
      logs: [],
      config: {
        paginationCount: 0,
        paginationLimit: 10,
        paginationPage: 1,
      }
    },

    isAddAccountNoteLoading: false,
    isAddAccountNoteError: false,
    addAccountNoteErrorResponse: '',

    balance: "",
    isBalanceLoading: false,
    isBalanceError: false,
    isBalanceErrorResponse: null,

    resetCopLoading: false,
    resetCopError: false,
    resetCopErrorResponse: null,
  };
}

const state = getDefaultState();

const mutations = {
  SET_CURRENTACCOUNT_AUDIT_LOADING(state,payload){ state.currentAccountAuditLoading = payload; },
  SET_CURRENTACCOUNT_AUDIT(state,payload){
    state.currentAccountAudit.config.paginationCount = parseInt(payload.headers['pagination-count']);
    state.currentAccountAudit.logs = payload.data;
    state.currentAccountAuditLoading = false;
  },
  SET_CURRENTACCOUNT_AUDIT_PAGINATION(state,options){
    state.currentAccountAudit.config.paginationLimit = options.itemsPerPage;
    state.currentAccountAudit.config.paginationPage = options.page;
  },
  RESET_CURRENTACCOUNT_AUDIT(state) {
    state.currentAccountAudit.logs = [];
    state.currentAccountAudit.config.paginationCount = 0;
    state.currentAccountAudit.config.paginationLimit = 10;
    state.currentAccountAudit.config.paginationPage = 1;
  },

  setAccounts(state, payload) {
    state.accounts = payload;
    state.accountsLoading = false;
  },
  setUsers(state, payload) {
    state.crmUsers = payload;
  },
  setCurrentAccount(state, payload) {
    state.currentAccount = payload;
    state.currentAccountLoading = false;
  },
  setCurrentAccountNotes(state, payload) {
    state.currentAccountNotes = payload.sort((a, b) => b.id - a.id);
  },
  setCurrentAccountNotesLoading(state, payload) {
    state.currentAccountNotesLoading = payload;
  },
  setCurrentAccountNotesError(state, payload) {
    state.currentAccountNotesError = payload;
  },
  setEscalation(state, payload) {
    state.accountEscalation = payload;
  },
  setCreditData(state, payload) {
    state.creditData = payload;
  },
  setCreditReasons(state, payload) {
    state.creditReasons = payload;
  },
  setCreditReasonLoading(state, payload) {
    state.creditReasonsLoading = payload;
  },
  resetState (state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    Object.assign(state, getDefaultState())
  },

  CREATE_ACCOUNT_NOTE_BEGIN(state) {
    state.isAddAccountNoteLoading = true;
    state.isAddAccountNoteError = false;
    state.addAccountNoteErrorResponse = null;
  },
  CREATE_ACCOUNT_NOTE_SUCCESS(state) {
    state.isAddAccountNoteLoading = false;
  },
  CREATE_ACCOUNT_NOTE_ERROR(state, err) {
    state.isAddAccountNoteLoading = false;
    state.isAddAccountNoteError = true;
    state.addAccountNoteErrorResponse = err;
  },

  FETCH_ACCOUNT_BALANCE_BEGIN(state) {
    state.isBalanceLoading = true;
    state.isBalanceError = false;
    state.isBalanceErrorResponse = null;
  },
  FETCH_ACCOUNT_BALANCE_SUCCESS(state, payload) {
    state.balance = payload.balance;
    state.isBalanceLoading = false;
  },
  FETCH_ACCOUNT_BALANCE_ERROR(state, err) {
    state.isBalanceLoading = false;
    state.isBalanceError = true;
    state.isBalanceErrorResponse = err;
  },

  UPDATE_ACCOUNT_BEGIN(state) {
    state.updateAccountLoading = true;
    state.updateAccountError = false;
    state.updateAccountErrorMessage = null;
  },

  UPDATE_ACCOUNT_SUCCESS(state, payload) {
    for(let key in state.currentAccount) {
      if(payload[key]) {
        state.currentAccount[key] = payload[key];
      }
    }
    state.updateAccountLoading = false;
  },

  UPDATE_ACCOUNT_ERROR(state, err) {
    if(err.response.data.extra_data) {
      for(let key in state.currentAccount) {
        if(err.response.data.extra_data[key]) {
          state.currentAccount[key] = err.response.data.extra_data[key];
        }
      }
    }
    state.updateAccountLoading = false;
    state.updateAccountError = true;
    state.updateAccountErrorMessage = err;
  },

  RESET_COP_BEGIN(state) {
    state.resetCopLoading = true;
    state.resetCopError = false;
    state.resetCopErrorResponse = null;
  },
  RESET_COP_SUCCESS(state) {
    state.resetCopLoading = false;
  },
  RESET_COP_ERROR(state, err) {
    state.resetCopLoading = false;
    state.resetCopError = true;
    state.resetCopErrorResponse = err;
  }
};

const actions = {
  async fetchCurrentAccountAudit({state,commit,dispatch},id){
    commit('SET_CURRENTACCOUNT_AUDIT_LOADING',true);
    try{
      let data = await accounts.getAccountAuditByID(id,state.currentAccountAudit.config);
      if(data.status===200){
        commit('SET_CURRENTACCOUNT_AUDIT',data);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: data.response.data.message}, { root: true });
      }
    }catch(error){
      dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
    }
  },
  async updateCurrentAccountAuditPagination({commit,dispatch},{id,options}){
    commit('SET_CURRENTACCOUNT_AUDIT_PAGINATION',options);
    dispatch('fetchCurrentAccountAudit',id);
  },
  getAccounts({ commit }) {
    return accounts
      .loadAccounts()
      .then(response => {
        commit("setAccounts", response);
      })
      .catch(() => commit("setAccounts", []));
  },
  async getCRMUsers({ commit }) {
    return accounts.getCRMUsers().then(response => {
        let users = {};
        if(response.status===200){
          response.data.forEach(user=>{
            users[user.sid] = user.long_name;
          });
        }
        commit("setUsers", users);
      }).catch(() => commit("setAccounts", []));
  },

  getFilteredAccounts({ commit }, data) {
    return accounts
      .loadAccounts(data)
      .then(response => {
        commit("setAccounts", response);
      })
      .catch(() => commit("setAccounts", []));
  },

  async getCurrentAccountProm({ commit,dispatch }, data) {
    try{
      let res = await accounts.loadAccount(data);
      if(res.status===200){
        commit("setCurrentAccount",res.data);
      }else{
        commit("setCurrentAccount",{});
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit("setCurrentAccount",{});
      dispatch("alerts/setAlert", {type: "error",message: err.response.data.message}, { root: true });
    }
  },

  async getCurrentAccount({ commit }, data) {
    return accounts
      .loadAccount(data)
      .then(response => {
        return accounts
          .getAccountBalance(data)
          .then(response2 => {
            commit("setCurrentAccount", { ...response.data, ...response2.data });
          })
          .catch(() => {
            commit("setCurrentAccount", response.data);
          });
      })
      .catch(() => {
        commit("setCurrentAccount", {});
      });
  },

  getSearchedAccounts({ commit }, data) {
    return accounts
      .searchAccounts(data)
      .then(response => {
        commit("setAccounts", response);
      })
      .catch(() => commit("setAccounts", []));
  },

  getRecentEditedAccounts({ commit }) {
    return accounts
      .getRecentEditedAccounts()
      .then(response => {
        commit("setAccounts", response.data.map((n) => (
          {
            email_address: n.email_address,
            mobile_number: n.mobile_number,
            business_name: n.business_name,
            customer_name: `${n.first_name} ${n.last_name}`,
            phone_number: n.phone_number,
            reference: n.reference,
            account_id: n.id,
          }
        ))
        );
      })
      .catch(() => commit("setAccounts", []));
  },
  getAccountBalance(_, { id }) {
    return accounts.getAccountBalance(id);
  },
  getAccountNotes({ commit }, id) {
    commit("setCurrentAccountNotesLoading", true);
    return accounts
      .getAccountNotes(id)
      .then(response => {
        commit("setCurrentAccountNotes", response);
        commit('setCurrentAccountNotesLoading', false);
      })
      .catch(() => {
        commit("setCurrentAccountNotes", []);
        commit('setCurrentAccountNotesLoading', false);
        commit('setCurrentAccountNotesError', true);
      });
  },
  async createAccountNote({ commit, dispatch }, { id, data }) {
    commit('CREATE_ACCOUNT_NOTE_BEGIN');
    try {
      await accounts.createAccountNote(id, data);
      commit('CREATE_ACCOUNT_NOTE_SUCCESS');
      dispatch('accounts/getAccountNotes', id, {root: true});
      dispatch('alerts/setAlert', {type: 'success', message: 'Note added successfully'}, {root: true});
    } catch(err) {
      commit('CREATE_ACCOUNT_NOTE_ERROR', err.response.data);
      dispatch('alerts/setAlert', {type: 'error', message: `Error updating notes: ${err.response.data.message}`}, {root: true});
    }    
  },
  async getAccountEscalation({ commit }, id) {
    return accounts
      .getAccountEscalation(id)
      .then(res => {
        commit("setEscalation", res.data);
      })
      .catch(() => commit("setEscalation", false));
  },
  removeAccountEscalation({ commit }, id) {
    return accounts
      .removeAccountEscalation(id)
      .then(() => {
        return commit("setEscalation", false);
      })
      .catch(() => commit("setEscalation", false));
  },
  async getCreditData({ commit }, id) {
    return accounts
      .getCreditData(id)
      .then(res => {
        commit("setCreditData", res.data);
      })
      .catch(() => {
        commit("setCreditData", {});
      });
  },
  resetAccountState({ commit }) {
    commit("resetState");
  },
  async getCreditReasons({ commit }) {
    commit("setCreditReasonLoading", true);
    return accounts
      .getCreditReasons()
      .then(res => {
        commit("setCreditReasons", res.data);
        commit("setCreditReasonLoading", false);
      })
      .catch(() => {
        commit("setCreditReasons", {});
        commit("setCreditReasonLoading", false);
      });
  },
  async updateAccount({ commit, dispatch }, { id, data }) {
    commit("UPDATE_ACCOUNT_BEGIN");
    try {
      const response = await accounts.updateAccount(id, data);
      commit("UPDATE_ACCOUNT_SUCCESS", response.data);
      dispatch("alerts/setAlert", {type: 'success', message: `Account updated successfully`}, {root: true});
    } catch(error) {
      if(error.response.status === 400) {
        commit("UPDATE_ACCOUNT_ERROR", error);
        dispatch("alerts/setAlert", {type: 'error', message: `Error updating account: ${error.response.data.message}`}, {root: true});
      } else {
        commit("UPDATE_ACCOUNT_ERROR", error);
        dispatch("alerts/setAlert", {type: 'error', message: `Error updating account: ${error.response.data.message}`}, {root: true});
      }
    }
  },
  async sendBrochure({ dispatch }, { id, product_kind }) {
    try {
      const response = await accounts.sendBrochure(id, product_kind);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Brochure sent successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending brochure: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending brochure: ${error}`}, {root: true});
    }
  },
  async sendPaymentLinkEmail({ dispatch }, id) {
    try {
      const response = await accounts.sendPaymentLinkEmail(id);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Sent payment link email successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending payment link: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending paymant link: ${error}`}, {root: true});
    }
  },
  async sendPaymentLinkSMS({ dispatch }, id) {
    try {
      const response = await accounts.sendPaymentLinkSMS(id);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Sent payment link SMS successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending payment link: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending paymant link: ${error}`}, {root: true});
    }
  },
  async sendAccStatement({ dispatch }, id) {
    try {
      const response = await accounts.sendAccStatement(id);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Sent account statement successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending account statement: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending account statement: ${error}`}, {root: true});
    }
  },
  async sendDDMandate({ dispatch }, id) {
    try {
      const response = await accounts.sendDDMandate(id);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Sent direct debit mandate successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending direct debit mandate: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending direct debit mandate: ${error}`}, {root: true});
    }
  },
  async sendContactRequest({ dispatch }, id) {
    try {
      const response = await accounts.sendContactRequest(id);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Sent contact request email successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending contact request email: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending contact request email: ${error}`}, {root: true});
    }
  },
  async addEscalation({ dispatch }, { id, data }) {
    try {
      const response = await accounts.addEscalation(id, data);
      
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Added escalation successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error adding escalation: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error adding escalation: ${error}`}, {root: true});
        throw error;
    }
  },
  async sendPortalInvite({ dispatch }, id) {
    try {
      const response = await accounts.sendPortalInvite(id);
      console.log(response);
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type: 'success',  message: `Portal invitation sent successfully`}, {root: true});
      } else {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending portal invitation: ${response.status}`}, {root: true});
      }
    } catch(error) {
        dispatch("alerts/setAlert", {type: 'error',  message: `Error sending portal invitation: ${error}`}, {root: true});
    }
  },
  async fetchAccountBalance({ commit }, id) {
    commit("FETCH_ACCOUNT_BALANCE_BEGIN");
    try {
      const response = await accounts.getAccountBalance(id);
      commit("FETCH_ACCOUNT_BALANCE_SUCCESS", response.data);
    } catch(err) {
      commit("FETCH_ACCOUNT_BALANCE_ERROR", err);
    }
  },

  async resetCop({commit, dispatch}, accountId) {
    commit('RESET_COP_BEGIN');
    try {
      const data = await accounts.resetCop(accountId);
      commit('RESET_COP_SUCCESS');
      dispatch('alerts/setAlert', {type: 'success',  message: data.data}, {root: true});
    } catch(err) {
      commit('RESET_COP_ERROR', err);
      dispatch('alerts/setAlert', {type: 'error',  message: err.response.data.message}, {root: true});
    }
  }
};

const getters = {
  getCurrentAccount: state => state.currentAccount,
  getIsUpdateAccountLoading: state => state.updateAccountLoading,
  getIsUpdateAccountError: state => state.updateAccountError,
  getIsUpdateAccountErrorMessage: state => state.updateAccountErrorMessage,

  getCreditReasonsOrdered: (state) => state.creditReasons.sort((a,b) => a.value.localeCompare(b.value)),
  getCreditReasonsLoading: (state) => state.creditReasonsLoading,
  getCurrentAccountAuditG: state => state.currentAccountAudit.logs,

  getCurrentAccountNotesError: (state) => state.currentAccountNotesError,
  getAddAccountNoteLoading: (state) => state.isAddAccountNoteLoading,
  getAddAccountNoteError: (state) => state.isAddAccountNoteError,

  getBalance: state => state.balance,
  getIsBalanceLoading: state => state.isBalanceLoading,
  getIsBalanceError: state => state.isBalanceError,
  getIsBalanceErrorResponse: state => state.isBalanceErrorResponse,

  getResetCopLoading: state => state.resetCopLoading,
  getResetCopError: state => state.resetCopError,
  getResetCopErrorResponse: state => state.resetCopErrorResponse,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
  modules: {
    ddMandateHistory
  }
};
